import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-391ea650"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "item__header" }
const _hoisted_2 = { class: "item__value" }

import { IonList, IonListHeader, IonItem, IonLabel, } from '@ionic/vue';
import { TAttribute } from '@/const/types/attributes';

interface Props {
  attributes: TAttribute[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BasicAttributesList',
  props: {
    attributes: null
  },
  setup(__props: any) {

const props = __props as {
  attributes: TAttribute[];
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonList), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonListHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonLabel), null, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default")
            ]),
            _: 3
          })
        ]),
        _: 3
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.attributes, (attribute) => {
        return (_openBlock(), _createBlock(_unref(IonItem), {
          key: attribute.id
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(IonLabel), { class: "item__inner" }, {
              default: _withCtx(() => [
                _createElementVNode("h2", _hoisted_1, _toDisplayString(attribute.name) + ": ", 1),
                _createElementVNode("p", _hoisted_2, _toDisplayString(attribute.value), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _: 3
  }))
}
}

})